import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox, Message } from 'semantic-ui-react'
import { generate as genId } from 'shortid'
import { createInterview } from '../../actions'
import { connect } from 'react-redux'
import { SubeditorArea } from '~/common/subeditor'
import CreateInvoice from './interview/createInvoice'

class Products extends PureComponent {
  state = {
    selectedProducts: List(),
    open: false,
  }

  render() {
    let { project = Map(), createInterview, loading, takenProducts, allTaken, error } = this.props

    let products = project.get('products', List())
    let interviews = project.get('interviews', List())

    let { selectedProducts, open } = this.state

    let titleProps = {}
    if (open || !allTaken) titleProps.attached = 'top'

    return (
      <div className="subeditor-container">
        <SubeditorArea title="Tuotteet">
          {error ? <Message content={error} error /> : null}
          <Table selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell content="Nimi" />
                <Table.HeaderCell content="Hinta" />
                <Table.HeaderCell content="Alennus" />
                <Table.HeaderCell content="Loppuhinta" />
                <Table.HeaderCell content="Laskutettu" />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {products.map(product => {
                let id = product.get('id')
                let selected = selectedProducts.contains(id)
                let taken = takenProducts.contains(id)

                let price = product.get('row_price')
                let discount = product.get('row_discount')
                let total = (price * (100 - discount)) / 100

                let invoiced = product.getIn(['row_data', 'invoiced'])

                if (!invoiced && invoiced !== 0) {
                  let invoiceType = product.get('invoice_type')
                  let invoicedPart = invoiceType === 'no_front' ? 0 : invoiceType === 'half_front' ? 50 : 100
                  invoiced = (total / 100) * invoicedPart
                  invoiced = Math.round(invoiced * 100) / 100
                }

                return (
                  <Table.Row
                    key={id}
                    disabled={taken}
                    onClick={e => {
                      if (taken) return

                      this.setState({
                        selectedProducts: selected
                          ? selectedProducts.remove(selectedProducts.indexOf(id))
                          : selectedProducts.push(id),
                      })
                    }}>
                    <Table.Cell>
                      <Checkbox checked={selected} disabled={taken} />
                      {product.get('name')}
                    </Table.Cell>
                    <Table.Cell>{price}€</Table.Cell>
                    <Table.Cell>{discount}%</Table.Cell>
                    <Table.Cell>{total}€</Table.Cell>
                    <Table.Cell>{invoiced}€</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="6">
                  <Button
                    content="Luo haastattelu"
                    icon="plus"
                    size="tiny"
                    disabled={!selectedProducts.size || loading}
                    onClick={e => {
                      e.preventDefault()
                      if (loading) return

                      let data = Map()
                      createInterview(project.get('id'), data.set('products', selectedProducts))

                      this.setState({
                        selectedProducts: List(),
                      })
                    }}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </SubeditorArea>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    project: state.activeProject,
    loading: state.projectCreateInterviewLoading,
    error: state.projectCreateInterviewError,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createInterview: (projectId, interview) => dispatch(createInterview(projectId, interview)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Products)

export function InterviewProducts(props) {
  let { interview = Map(), productsById = Map() } = props
  return (
    <SubeditorArea title="Liitetyt tuotteet">
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell content="Tuote" />
            <Table.HeaderCell content="Hinta" />
            <Table.HeaderCell content="Alennus" />
            <Table.HeaderCell content="Loppuhinta" />
            <Table.HeaderCell content="Laskutettu" />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {interview.getIn(['data', 'products'], List()).map(id => {
            let product = productsById.get(id, Map())

            let price = product.get('row_price')
            let discount = product.get('row_discount')
            let total = (price * (100 - discount)) / 100

            let invoiced = product.getIn(['row_data', 'invoiced'])
            if (!invoiced && invoiced !== 0) {
              let invoiceType = product.get('invoice_type')
              let invoicedPart = invoiceType === 'no_front' ? 0 : invoiceType === 'half_front' ? 50 : 100
              invoiced = (total / 100) * invoicedPart
              invoiced = Math.round(invoiced * 100) / 100
            }

            return (
              <Table.Row key={id}>
                <Table.Cell>{product.get('name')}</Table.Cell>
                <Table.Cell>{price}€</Table.Cell>
                <Table.Cell>{discount}%</Table.Cell>
                <Table.Cell>{total}€</Table.Cell>
                <Table.Cell>{invoiced}€</Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
      <CreateInvoice {...props} />
    </SubeditorArea>
  )
}
